import type { FC } from 'react';
import React from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@wwe-portal/ui/lib/lib';

const iconVariants = cva('', {
  variants: {
    size: {
      small: 'w-[15px] h-[15px]',
      default: 'w-[17px] h-[17px]',
      large: 'w-[19px] h-[19px]',
    },
    color: {
      green: 'text-green700',
      white: 'text-text300',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export type ClubCurrencyIconSimpleProps =
  React.ReactComponentElement<'svg'>['props'] & {
    size?: 'small' | 'default' | 'large';
    color?: 'green' | 'white';
  };
export const ClubCurrencySimpleIcon: FC<ClubCurrencyIconSimpleProps> = ({
  className,
  size,
  color,
  ...props
}) => {
  return (
    <svg
      className={cn(iconVariants({ size, color }), className)}
      viewBox="0 0 55 55"
      {...props}
    >
      <path
        d="M43.7403 30.5337V35.4814L27.4795 42.8108L11.2188 35.4814V30.5337L18.1441 33.6526V22.7719L11.2188 19.653V14.7053L23.0918 20.0571V35.8855L27.4795 37.8631L31.8602 35.8855V20.0571L43.7332 14.7053V19.653L36.815 22.7719V33.6526L43.7403 30.5337Z"
        fill="currentColor"
      />
      <path
        clipRule="evenodd"
        d="M27.4781 50.1479C40.1432 50.1479 50.4104 39.8808 50.4104 27.2156C50.4104 14.5505 40.1432 4.28335 27.4781 4.28335C14.8129 4.28335 4.54581 14.5505 4.54581 27.2156C4.54581 39.8808 14.8129 50.1479 27.4781 50.1479ZM27.4781 54.1586C42.3583 54.1586 54.421 42.0958 54.421 27.2156C54.421 12.3355 42.3583 0.272705 27.4781 0.272705C12.5979 0.272705 0.535156 12.3355 0.535156 27.2156C0.535156 42.0958 12.5979 54.1586 27.4781 54.1586Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
